export const FilestackDecorator = data => ({
	url: data.url,
	name: data.filename,
	size: data.size,
	mimeType: data.mimetype,
});

export const FilestackUploadDecorator = data => ({
	url: data.url,
	name: data._file?.name,
	size: data._file?.size,
	mimeType: data._file?.type,
});
